<div class="new-screen6">
  <div class="container flex flex-col">
    <h5 class="all-head">Trending Images</h5>
    <div class="flex display-mob max-md:!flex-col md:flex-row md:gap-[20px]">

      @if (conv_image?.length > 0) {
        <div class="md-brdr-btm inconv1 max-md:!flex-[1_1_100%] md:flex-[1_1_33.33%]">
          <a class="testvideo" [routerLink]="['/key-takeaways', conv_image[0].slug, conv_image[0]._id]">
            <div class="mrg-after-imgvid">
              <picture>
                <source type="image/webp" srcset="{{ conv_image[0]?.thumbnail_url }}">
                <img src="{{ conv_image[0]?.url }}" style="width:100%" alt="{{ conv_image[0]?.headline }}" />
              </picture>
            </div>
          </a>
          <a class="testvideo" [routerLink]="['/key-takeaways', conv_image[0].slug, conv_image[0]._id]">
            <p class="internal-updates-head">{{ conv_image[0]?.headline }}</p>
          </a>
        </div>
      }


      @if (conv_image?.length > 1) {
        <div class="md-brdr-btm inconv1 max-md:!flex-[1_1_100%] md:flex-[1_1_33.33%]">
          <a class="testvideo" [routerLink]="['/key-takeaways', conv_image[1].slug, conv_image[1]._id]">
            <div class="mrg-after-imgvid">
              <picture>
                <source type="image/webp" srcset="{{ conv_image[1]?.thumbnail_url }}">
                <img src="{{ conv_image[1]?.url }}" style="width:100%" alt="{{ conv_image[1]?.headline }}" />
              </picture>
            </div>
          </a>
          <a class="testvideo" [routerLink]="['/key-takeaways', conv_image[1].slug, conv_image[1]._id]">
            <p class="internal-updates-head">{{ conv_image[1]?.headline }}</p>
          </a>
        </div>
      }




      <div class="inconv1 max-md:!flex-[1_1_100%] md:flex-[1_1_33.33%]">
        <ul class="flex flex-col">
          @if (conv_image?.length > 2) {
            @for (item of conv_image.slice(2, 6); track item) {
              <a class="testvideo" [routerLink]="['/key-takeaways', item.slug, item._id]">
                <li class="brdr-btm">
                  <!-- <p class="internal-dr-name">{{ item.doctor_name }}</p> -->
                  <p class="internal-updates-head">{{ item.headline }}</p>
                </li>
              </a>
            }
          }

        </ul>
      </div>
    </div>
    <a class="testvideo" href="{{env.frontend_url}}images/">
      <button mat-flat-button class="view-all-btn">View all</button></a>
    </div>
  </div>